import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
    tag: {
        slug: string;
        name: string;
    };
    isSystem?: boolean;
}

export const TagBadge: React.FC<Props> = ({ tag, isSystem = false }) => {
    if (!tag.slug) return null;
    return (
        <Link to={`/tags/${tag.slug}`} className="no-underline text-current">
            <div
                className={`flex flex-row rounded-full items-center justify-between py-1 px-2 border ${
                    isSystem ? 'border-gray-400' : 'border-balloon'
                }`}
            >
                <p
                    className={`m-0 font-light p-0 ${isSystem ? 'text-gray-500' : 'text-balloon'}`}
                    style={{ fontSize: 13 }}
                >
                    #{tag.name || tag.slug}
                </p>
            </div>
        </Link>
    );
};